import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { IPaymentRequestApiClient } from './i-payment-request.api.client';
import { IPaginationParameters, IPaginationResponse } from '../../../common';
import { IPaymentRequestResponse } from '../dtos';
import { paymentRequestsData } from '../data';

@Injectable({
  providedIn: 'root'
})
export class PaymentRequestInMemoryApiClient implements IPaymentRequestApiClient {
  get(paginationParameters?: IPaginationParameters): Observable<IPaginationResponse<IPaymentRequestResponse>> {
    return of(paymentRequestsData.paymentRequestsResponse);
  }

  getById(id: string): Observable<IPaymentRequestResponse> {
    return of(paymentRequestsData.paymentRequestResponse);
  }
}